import { render, staticRenderFns } from "./icon_arrow.vue?vue&type=template&id=c1b53cd2"
import script from "./icon_arrow.vue?vue&type=script&lang=js"
export * from "./icon_arrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports